// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════
   Shell
   ══════════════════════════════════════════════════════ */
.App_shell__1G2Ca {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--bg);
}

/* ══════════════════════════════════════════════════════
   Header
   ══════════════════════════════════════════════════════ */
.App_header__fhC8n {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 clamp(12px, 2vw, 28px);
  min-height: clamp(44px, 6vh, 56px);
  border-bottom: 1px solid var(--border);
  background: var(--bg-card);
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
  gap: 12px;
  flex-wrap: wrap;
}

.App_logo__7Edbg {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: clamp(14px, 1.4vw, 18px);
  font-weight: 600;
  color: var(--accent);
  letter-spacing: -0.01em;
  flex-shrink: 0;
}

.App_headerMeta__NZ5se {
  display: flex;
  align-items: center;
  gap: clamp(6px, 0.8vw, 12px);
  flex-wrap: wrap;
}

.App_fileName__n-w-P {
  font-size: clamp(10px, 1vw, 12px);
  color: var(--text-secondary);
  font-family: var(--mono);
  max-width: clamp(100px, 15vw, 220px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.App_pill__RQ45j {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(10px, 0.9vw, 11px);
  font-weight: 500;
  padding: 3px clamp(6px, 0.8vw, 9px);
  border-radius: 20px;
  background: var(--accent-dim);
  color: var(--accent);
  border: 1px solid var(--accent-border);
  white-space: nowrap;
}

.App_resetBtn__pi8Jm {
  display: flex;
  align-items: center;
  gap: clamp(4px, 0.5vw, 6px);
  font-size: clamp(11px, 1vw, 12px);
  font-weight: 500;
  padding: clamp(4px, 0.6vh, 6px) clamp(8px, 1vw, 12px);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: transparent;
  color: var(--text-secondary);
  transition: background 0.15s, color 0.15s;
  white-space: nowrap;
}
.App_resetBtn__pi8Jm:hover {
  background: var(--bg-card-hover);
  color: var(--text-primary);
}

.App_accentBtn__X21GN {
  display: flex;
  align-items: center;
  gap: clamp(4px, 0.5vw, 6px);
  font-size: clamp(11px, 1vw, 12px);
  font-weight: 600;
  padding: clamp(4px, 0.6vh, 7px) clamp(10px, 1.2vw, 16px);
  border-radius: var(--radius-sm);
  border: none;
  background: var(--accent);
  color: #0a0a0a;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
}
.App_accentBtn__X21GN:hover { background: #e8c069; }

.App_printBtn__ms2e8 {
  display: flex;
  align-items: center;
  gap: clamp(4px, 0.5vw, 6px);
  padding: clamp(4px, 0.6vh, 7px) clamp(8px, 1vw, 14px);
  border-radius: var(--radius-sm);
  border: 1px solid var(--accent-border);
  background: var(--accent-dim);
  color: var(--accent);
  font-size: clamp(11px, 1vw, 12px);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}
.App_printBtn__ms2e8:hover:not(:disabled) {
  background: rgba(212,168,67,0.2);
  border-color: var(--accent);
}
.App_printBtn__ms2e8:disabled { opacity: 0.3; cursor: not-allowed; }

/* ══════════════════════════════════════════════════════
   Mapping Screen
   ══════════════════════════════════════════════════════ */
.App_mappingMain__olV7f {
  flex: 1 1;
  padding: clamp(16px, 3vh, 32px) clamp(14px, 3vw, 28px);
  max-width: min(860px, 100%);
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: clamp(14px, 2.5vh, 24px);
}

.App_mappingHero__ERTMW {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: clamp(12px, 2vw, 20px);
  flex-wrap: wrap;
}

.App_mappingHeroText__u0skE { display: flex; flex-direction: column; gap: 6px; }

.App_mappingTitle__RT26L {
  font-size: clamp(14px, 1.8vw, 18px);
  font-weight: 600;
  color: var(--text-primary);
  letter-spacing: -0.02em;
  display: flex;
  align-items: center;
  gap: 8px;
}

.App_mappingSub__cFZ\\+r {
  font-size: clamp(11px, 1.1vw, 13px);
  color: var(--text-secondary);
  line-height: 1.5;
  max-width: 520px;
}

.App_mappingGrid__Vsyiw { display: flex; flex-direction: column; gap: clamp(5px, 0.8vh, 8px); }

.App_mappingRow__hRcej {
  display: flex;
  align-items: center;
  gap: clamp(8px, 1vw, 12px);
  padding: clamp(8px, 1.2vh, 12px) clamp(10px, 1.5vw, 16px);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--bg-card);
  transition: border-color 0.15s;
  flex-wrap: wrap;
}

.App_mappingRowResolved__eVL3L  { border-color: rgba(74,158,110,0.3); background: rgba(74,158,110,0.05); }
.App_mappingRowUnresolved__xgMeR{ border-color: rgba(212,168,67,0.35); background: rgba(212,168,67,0.05); }

.App_mappingFieldKey__lknGS {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: clamp(10px, 1vw, 12px);
  font-weight: 600;
  font-family: var(--mono);
  color: var(--text-primary);
  min-width: clamp(120px, 15vw, 180px);
  letter-spacing: 0.02em;
}

.App_mappingArrow__fglhS   { color: var(--text-muted); flex-shrink: 0; }
.App_resolvedIcon__KnOCJ   { color: var(--success); flex-shrink: 0; }
.App_warnIcon__O5y\\+U       { color: var(--accent); flex-shrink: 0; }

.App_mappingSelect__\\+a76a {
  flex: 1 1;
  min-width: 120px;
  padding: clamp(5px, 0.8vh, 7px) 10px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: clamp(11px, 1.1vw, 12.5px);
  font-family: var(--sans);
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s;
}
.App_mappingSelect__\\+a76a:focus     { border-color: var(--accent); }
.App_mappingSelectWarn__2JYY1       { border-color: rgba(212,168,67,0.5); color: var(--text-secondary); }

.App_confirmBtn__dY1pQ {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: clamp(7px, 1vh, 9px) clamp(14px, 1.5vw, 20px);
  border-radius: var(--radius-sm);
  border: none;
  background: var(--accent);
  color: #0f0f0f;
  font-size: clamp(11px, 1.1vw, 13px);
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
  flex-shrink: 0;
}
.App_confirmBtn__dY1pQ:hover { background: #e8c069; }

.App_mappingFooter__68uEv {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-top: 8px;
  flex-wrap: wrap;
}

.App_mappingFooterNote__6QR3N { font-size: clamp(10px, 1vw, 12px); color: var(--text-muted); }

/* ══════════════════════════════════════════════════════
   Results strip
   ══════════════════════════════════════════════════════ */
.App_resultsStrip__h0-U\\+ {
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  padding: 10px clamp(12px, 2vw, 20px);
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
}

.App_stripFields__UGwLM {
  display: grid;
  grid-template-columns: repeat(5, auto);
  gap: 8px 14px;
  align-items: flex-end;
}

.App_stripField__BQ9D1 { display: flex; flex-direction: column; gap: 3px; flex-shrink: 0; }

.App_stripLabel__IvuoJ {
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
  white-space: nowrap;
}

.App_inputWrap__W8dgk { position: relative; display: flex; align-items: center; }

.App_inputPrefix__O\\+vet {
  position: absolute;
  left: 8px;
  font-size: clamp(10px, 1vw, 12px);
  color: var(--text-muted);
  pointer-events: none;
  z-index: 1;
}

.App_stripInput__GUxcc {
  width: 80px;
  padding: 5px 8px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 12px;
  font-family: var(--mono);
  outline: none;
  transition: border-color 0.15s;
}
.App_stripInput__GUxcc:focus { border-color: var(--accent); }
.App_stripInput__GUxcc::placeholder { color: var(--text-muted); }
.App_inputFieldPrefixed__jv-Dy { padding-left: clamp(18px, 2vw, 22px); }

.App_stripTextInput__kw4xN {
  width: 110px;
  padding: 5px 8px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: 12px;
  font-family: var(--sans);
  outline: none;
  transition: border-color 0.15s;
}
.App_stripTextInput__kw4xN:focus { border-color: var(--accent); }
.App_stripTextInput__kw4xN::placeholder { color: var(--text-muted); font-style: italic; }

.App_stripSummary__ih-Sw { display: flex; gap: 16px; flex-wrap: nowrap; overflow: hidden; }
.App_stripStat__qGJHc { font-size: clamp(10px, 1vw, 12px); color: var(--text-secondary); }
.App_stripStat__qGJHc strong { color: var(--text-secondary); font-weight: 500; }

.App_bookToggle__Ieseu {
  display: flex;
  gap: 5px;
}
.App_bookToggleBtn__p2o-I {
  padding: 5px 12px;
  font-size: 11px;
  font-weight: 500;
  background: var(--bg-input);
  color: var(--text-muted);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background 0.12s, color 0.12s, border-color 0.12s;
  white-space: nowrap;
}
.App_bookToggleBtn__p2o-I:hover { color: var(--text-primary); border-color: var(--accent-border); }
.App_bookToggleActive__2wRav {
  background: var(--accent-dim) !important;
  color: var(--accent) !important;
  border-color: var(--accent) !important;
  font-weight: 600;
}

.App_stripResetBtn__esLf8 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(26px, 2.5vw, 30px);
  height: clamp(26px, 3vh, 30px);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
}
.App_stripResetBtn__esLf8:hover { color: var(--accent); border-color: var(--accent-border); }

/* ══════════════════════════════════════════════════════
   Results main
   ══════════════════════════════════════════════════════ */
.App_resultsMain__3kuf4 {
  flex: 1 1;
  padding: clamp(12px, 2vh, 24px) clamp(14px, 2vw, 28px);
  overflow-y: auto;
}

.App_resultsHeader__BGeej {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.App_resultsTitle__P6aDE {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: clamp(14px, 1.5vw, 20px);
  font-weight: 600;
  color: var(--text-primary);
}

.App_resultsTitleSub__WUipk { font-size: clamp(11px, 1.1vw, 13px); font-weight: 400; color: var(--text-muted); }

.App_filterPill__G2F-4 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: clamp(10px, 0.9vw, 11px);
  padding: 3px clamp(7px, 0.9vw, 10px);
  border-radius: 20px;
  background: var(--accent-dim);
  color: var(--accent);
  border: 1px solid var(--accent-border);
}

.App_noResults__w9NW1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: clamp(32px, 8vh, 60px) 20px;
  text-align: center;
  color: var(--text-muted);
  font-size: clamp(12px, 1.2vw, 14px);
}

/* ── Deal cards ── */
.App_dealCards__b16r7 { display: flex; flex-direction: column; gap: clamp(5px, 0.8vh, 8px); }

/* ── Deal card: horizontal at full width, stacks on small screens ── */
.App_dealCard__OqroL {
  display: grid;
  /* Wide: rank | identity | financials all on one row */
  grid-template-columns: 36px 1fr auto;
  grid-template-rows: auto;
  align-items: center;
  column-gap: 20px;
  padding: clamp(8px, 1.2vh, 14px) clamp(12px, 1.5vw, 20px);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--bg-card);
  transition: border-color 0.15s;
}
.App_dealCard__OqroL:hover   { border-color: var(--border-strong); }
.App_dealCardPos__Tn7bs      { border-left: 3px solid var(--success); }
.App_dealCardNeg__WsjTp      { border-left: 3px solid #b85c38; }

.App_dealRank__GoIrw {
  font-size: clamp(12px, 1.1vw, 15px);
  font-weight: 700;
  color: var(--text-secondary);
  font-family: var(--mono);
  text-align: center;
  flex-shrink: 0;
}

/* Identity: name on top, pills + equity below */
.App_dealIdentity__cqyMD {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.App_dealVehicle__gDtzj {
  font-size: clamp(13px, 1.3vw, 16px);
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.App_dealMeta__Nqk4Q {
  display: flex;
  flex-wrap: nowrap;
  gap: 5px;
  align-items: center;
}

.App_dealMetaItem__P9bdf {
  font-size: clamp(10px, 0.85vw, 11px);
  color: var(--text-secondary);
  background: var(--bg-input);
  padding: 2px 7px;
  border-radius: 4px;
  border: 1px solid var(--border);
  white-space: nowrap;
}
.App_dealMetaVin__dMuzW { display: none; }

.App_equityBadge__M3JjV {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 3px 10px;
  border-radius: var(--radius-sm);
  white-space: nowrap;
  flex-shrink: 0;
}
.App_equityBadgePos__Bn\\+Ka { background: var(--success-dim); border: 1px solid rgba(74,158,110,0.3); }
.App_equityBadgeNeg__rzE-0 { background: rgba(184,92,56,0.12); border: 1px solid rgba(184,92,56,0.3); }

.App_equityPct__Jdpa6   { font-size: clamp(12px, 1.1vw, 14px); font-weight: 700; font-family: var(--mono); color: var(--text-primary); }
.App_equityLabel__GjQfh { font-size: clamp(9px, 0.8vw, 10px); font-weight: 500; letter-spacing: 0.04em; color: var(--text-secondary); text-transform: uppercase; }

/* Financials: horizontal row at full width */
.App_dealFinancials__fYR1k {
  display: flex;
  flex-direction: row;
  gap: clamp(14px, 2vw, 28px);
  flex-shrink: 0;
  align-items: flex-start;
}

.App_dealFin__C8BvO         { display: flex; flex-direction: column; }
.App_dealFinLabel__RIL96    { font-size: clamp(9px, 0.75vw, 10px); color: var(--text-secondary); font-weight: 500; letter-spacing: 0.04em; text-transform: uppercase; line-height: 1.2; display: flex; align-items: center; gap: 4px; }
.App_dealFinVal__\\+g9CA      { font-size: clamp(12px, 1.1vw, 14px); font-weight: 500; color: var(--text-primary); font-family: var(--mono); line-height: 1.3; }
.App_dealFinPmt__FWuOc      { color: var(--accent); font-weight: 600; }
.App_dealFinActiveDot__6P6gP { width: 4px; height: 4px; border-radius: 50%; background: var(--accent); flex-shrink: 0; }

/* Responsive: below 860px stack identity above financials */
@media (max-width: 860px) {
  .App_dealCard__OqroL {
    grid-template-columns: 28px 1fr;
    grid-template-rows: auto auto;
  }
  .App_dealRank__GoIrw       { grid-row: 1 / 3; align-self: center; }
  .App_dealIdentity__cqyMD   { grid-column: 2; grid-row: 1; }
  .App_dealFinancials__fYR1k { grid-column: 2; grid-row: 2; flex-wrap: wrap; gap: 10px 20px; }
}

/* Responsive: below 500px wrap financials tightly */
@media (max-width: 500px) {
  .App_dealFinancials__fYR1k { gap: 8px 14px; }
  .App_dealVehicle__gDtzj    { font-size: 13px; }
}

.App_accentIcon__UqAgq { color: var(--accent); flex-shrink: 0; }

/* ══════════════════════════════════════════════════════
   Homepage
   ══════════════════════════════════════════════════════ */
.App_homepageShell__fG4YA {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0a0a0a;
  position: relative;
  overflow: hidden;
  padding: clamp(12px, 2vh, 20px) clamp(16px, 4vw, 32px);
}

.App_homepageBg__Sxcw0 { position: absolute; inset: 0; pointer-events: none; }

.App_bgGlow__dJAei {
  position: absolute;
  top: -20%;
  left: 50%;
  transform: translateX(-50%);
  width: min(700px, 90vw);
  height: clamp(200px, 40vh, 400px);
  background: radial-gradient(ellipse at center, rgba(212,168,67,0.07) 0%, transparent 70%);
  border-radius: 50%;
}

.App_homepageContent__sVkLj {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: min(580px, 100%);
  width: 100%;
  gap: 0;
}

.App_homeLogoRow__6LggL {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: clamp(8px, 1.5vh, 14px);
  opacity: 0.5;
}

.App_homeLogo__BiQes  { color: var(--accent); display: flex; }

.App_homeLogoText__kSt-n {
  font-size: clamp(10px, 1.1vw, 12px);
  font-weight: 500;
  color: var(--text-secondary);
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.App_homeTitle__I-LO1 {
  font-size: clamp(26px, 4.5vw, 44px);
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: #f0f0f0;
  margin-bottom: clamp(6px, 1vh, 10px);
}

.App_homeTitleAccent__ygi-q { color: var(--accent); }

.App_homeSubtitle__m4YLk {
  font-size: clamp(13px, 1.3vw, 15px);
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: clamp(12px, 2vh, 20px);
  max-width: 380px;
}

.App_homeDropZone__1vM2K {
  width: 100%;
  border: 1px solid #2a2a2a;
  border-radius: 14px;
  padding: clamp(14px, 2.5vh, 22px) clamp(16px, 2.5vw, 28px);
  cursor: pointer;
  background: #111111;
  transition: border-color 0.2s, background 0.2s;
  margin-bottom: clamp(10px, 1.8vh, 18px);
  outline: none;
}
.App_homeDropZone__1vM2K:hover,
.App_homeDropZone__1vM2K:focus-visible { border-color: var(--accent); background: rgba(212,168,67,0.04); }
.App_homeDropZoneActive__zsR2x         { border-color: var(--accent) !important; background: rgba(212,168,67,0.08) !important; }

.App_homeDropInner__R4jsc {
  display: flex;
  align-items: center;
  gap: clamp(10px, 1.5vw, 16px);
  text-align: left;
}

.App_homeDropIconWrap__\\+ZSVT {
  width: clamp(36px, 4vw, 44px);
  height: clamp(36px, 4vw, 44px);
  border-radius: 10px;
  background: rgba(212,168,67,0.1);
  border: 1px solid rgba(212,168,67,0.2);
  color: var(--accent);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.App_homeDropMain__tZEYb {
  font-size: clamp(13px, 1.4vw, 15px);
  font-weight: 500;
  color: #f0f0f0;
  margin-bottom: 3px;
}

.App_homeDropSub__dcBMk {
  font-size: clamp(10px, 1vw, 12px);
  color: var(--text-muted);
  font-family: var(--mono);
  letter-spacing: 0.02em;
}

.App_toyotaBtn__beOvP {
  width: 100%;
  border: 1px solid #2a2a2a;
  border-radius: 10px;
  padding: clamp(6px, 1vh, 9px) clamp(16px, 2.5vw, 28px);
  cursor: pointer;
  background: #111111;
  color: var(--text-secondary);
  font-size: clamp(11px, 1.1vw, 13px);
  font-weight: 500;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
  margin-bottom: clamp(10px, 1.8vh, 18px);
}
.App_toyotaBtn__beOvP:hover:not(:disabled) { border-color: var(--accent); background: rgba(212,168,67,0.04); color: var(--accent); }
.App_toyotaBtn__beOvP:disabled { opacity: 0.35; cursor: not-allowed; }

.App_bubbleRow__xE8HR {
  display: flex;
  gap: clamp(8px, 1.2vw, 12px);
  width: 100%;
  flex-wrap: wrap;
}

.App_bubble__nkS\\+b {
  flex: 1 1;
  min-width: clamp(130px, 20vw, 160px);
  background: #111111;
  border: 1px solid #1e1e1e;
  border-radius: 14px;
  padding: clamp(12px, 2vh, 18px) clamp(12px, 1.6vw, 20px);
  text-align: left;
  transition: border-color 0.2s;
}
.App_bubble__nkS\\+b:hover { border-color: #2a2a2a; }

.App_bubbleTitle__FDbXM {
  font-size: clamp(10px, 1vw, 12px);
  font-weight: 600;
  color: var(--accent);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: clamp(8px, 1.2vh, 12px);
}

.App_bubbleList__1XG08 { list-style: none; display: flex; flex-direction: column; gap: clamp(5px, 0.8vh, 7px); }

.App_bubbleItem__seDpk {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: clamp(10px, 1vw, 12px);
  color: var(--text-secondary);
  line-height: 1.4;
}

.App_bubbleDot__PV7-N {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--accent);
  opacity: 0.6;
  flex-shrink: 0;
}

/* ══════════════════════════════════════════════════════
   Inputs screen (kept for reference, unused in flow)
   ══════════════════════════════════════════════════════ */
.App_inputField__Z1sjo {
  width: 100%;
  padding: clamp(6px, 0.9vh, 8px) 10px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: clamp(11px, 1.1vw, 13px);
  font-family: var(--mono);
  outline: none;
  transition: border-color 0.15s;
}
.App_inputField__Z1sjo:focus { border-color: var(--accent); }
.App_inputField__Z1sjo::placeholder { color: var(--text-muted); font-family: var(--sans); }

/* ── Cards wrap + loading overlay ── */
.App_cardsWrap__BOSoD {
  position: relative;
  min-height: 120px;
}

/* Blurs the cards behind the overlay while keeping header/strip fully usable */
.App_cardsOverlay__GPUbh {
  position: absolute;
  inset: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(10, 10, 10, 0.75);
  backdrop-filter: blur(4px);
  border-radius: var(--radius);
}

.App_loadingSpinner__mIlB6 {
  width: 28px;
  height: 28px;
  border: 2px solid var(--border-strong);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: App_spin__RBUaI 0.7s linear infinite;
}

@keyframes App_spin__RBUaI {
  to { transform: rotate(360deg); }
}

.App_loadingText__qJ1ef {
  font-size: 12px;
  color: var(--text-secondary);
  letter-spacing: 0.03em;
}

/* ══════════════════════════════════════════════════════
   Unified results header
   ══════════════════════════════════════════════════════ */
.App_uniHeader__g7P-j {
  background: var(--bg-card);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

/* Top bar */
.App_uniTop__sGmT8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  border-bottom: 1px solid var(--border);
  gap: 16px;
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--bg-card);
}

.App_uniActions__ygNrc {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Inputs row */
.App_uniInputs__dxrKy {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  padding: 12px 24px;
  flex-wrap: wrap;
}

.App_uniField__zjNee {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex-shrink: 0;
}

.App_uniDivider__oqE9F {
  width: 1px;
  align-self: stretch;
  margin: 2px 2px 4px;
  background: var(--border-strong);
  flex-shrink: 0;
}

.App_uniLabel__gNHCR {
  font-size: clamp(9px, 0.8vw, 11px);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
  white-space: nowrap;
}

.App_uniInput__VZepD {
  width: clamp(70px, 6vw, 96px);
  padding: clamp(5px, 0.6vh, 8px) clamp(7px, 0.6vw, 10px);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: clamp(12px, 1vw, 14px);
  font-family: var(--mono);
  outline: none;
  transition: border-color 0.15s;
}
.App_uniInput__VZepD:focus { border-color: var(--accent); }
.App_uniInput__VZepD::placeholder { color: var(--text-muted); font-family: var(--sans); font-size: clamp(10px, 0.8vw, 11px); }

.App_uniTextInput__eAZBs {
  width: clamp(90px, 9vw, 130px);
  padding: clamp(5px, 0.6vh, 8px) clamp(7px, 0.6vw, 10px);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-strong);
  background: var(--bg-input);
  color: var(--text-primary);
  font-size: clamp(12px, 1vw, 14px);
  font-family: var(--sans);
  outline: none;
  transition: border-color 0.15s;
}
.App_uniTextInput__eAZBs:focus { border-color: var(--accent); }
.App_uniTextInput__eAZBs::placeholder { color: var(--text-muted); font-size: clamp(10px, 0.8vw, 11px); }
`, "",{"version":3,"sources":["webpack://./src/App.module.css"],"names":[],"mappings":"AAAA;;2DAE2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;2DAE2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;EAClC,sCAAsC;EACtC,0BAA0B;EAC1B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,cAAc;EACd,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;EAChB,mCAAmC;EACnC,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,qDAAqD;EACrD,+BAA+B;EAC/B,sCAAsC;EACtC,uBAAuB;EACvB,4BAA4B;EAC5B,yCAAyC;EACzC,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,iCAAiC;EACjC,gBAAgB;EAChB,wDAAwD;EACxD,+BAA+B;EAC/B,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;AACA,8BAAmB,mBAAmB,EAAE;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,qDAAqD;EACrD,+BAA+B;EAC/B,sCAAsC;EACtC,6BAA6B;EAC7B,oBAAoB;EACpB,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gDAAgD;AAClD;AACA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;AACA,gCAAqB,YAAY,EAAE,mBAAmB,EAAE;;AAExD;;2DAE2D;AAC3D;EACE,SAAO;EACP,sDAAsD;EACtD,2BAA2B;EAC3B,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,8BAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEpE;EACE,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,0BAAe,aAAa,EAAE,sBAAsB,EAAE,2BAA2B,EAAE;;AAEnF;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,yDAAyD;EACzD,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA,kCAAuB,kCAAkC,EAAE,iCAAiC,EAAE;AAC9F,kCAAuB,mCAAmC,EAAE,iCAAiC,EAAE;;AAE/F;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,6BAAkB,wBAAwB,EAAE,cAAc,EAAE;AAC5D,6BAAkB,qBAAqB,EAAE,cAAc,EAAE;AACzD,8BAAkB,oBAAoB,EAAE,cAAc,EAAE;;AAExD;EACE,SAAO;EACP,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,sCAAsC;EACtC,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;AACA,uCAA2B,2BAA2B,EAAE;AACxD,sCAA2B,kCAAkC,EAAE,4BAA4B,EAAE;;AAE7F;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sDAAsD;EACtD,+BAA+B;EAC/B,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;AAChB;AACA,+BAAoB,mBAAmB,EAAE;;AAEzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gCAAqB,iCAAiC,EAAE,wBAAwB,EAAE;;AAElF;;2DAE2D;AAC3D;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,qBAAqB;AACvB;;AAEA,yBAAc,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,cAAc,EAAE;;AAE/E;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,wBAAa,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;;AAErE;EACE,kBAAkB;EAClB,SAAS;EACT,iCAAiC;EACjC,wBAAwB;EACxB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;EACtC,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;AACA,+BAAoB,2BAA2B,EAAE;AACjD,sCAA2B,wBAAwB,EAAE;AACrD,iCAAsB,oCAAoC,EAAE;;AAE5D;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,sCAAsC;EACtC,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;AACA,mCAAwB,2BAA2B,EAAE;AACrD,0CAA+B,wBAAwB,EAAE,kBAAkB,EAAE;;AAE7E,2BAAgB,aAAa,EAAE,SAAS,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC/E,wBAAa,iCAAiC,EAAE,4BAA4B,EAAE;AAC9E,+BAAoB,4BAA4B,EAAE,gBAAgB,EAAE;;AAEpE;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;AACrB;AACA,kCAAuB,0BAA0B,EAAE,kCAAkC,EAAE;AACvF;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;EAC9B,+BAA+B;EAC/B,sCAAsC;EACtC,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;EACf,2CAA2C;AAC7C;AACA,kCAAuB,oBAAoB,EAAE,kCAAkC,EAAE;;AAEjF;;2DAE2D;AAC3D;EACE,SAAO;EACP,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,8BAAmB,mCAAmC,EAAE,gBAAgB,EAAE,wBAAwB,EAAE;;AAEpG;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB,wBAAa,aAAa,EAAE,sBAAsB,EAAE,2BAA2B,EAAE;;AAEjF,uEAAuE;AACvE;EACE,aAAa;EACb,sDAAsD;EACtD,oCAAoC;EACpC,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,yDAAyD;EACzD,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;AAChC;AACA,+BAAoB,kCAAkC,EAAE;AACxD,+BAAoB,qCAAqC,EAAE;AAC3D,+BAAoB,8BAA8B,EAAE;;AAEpD;EACE,mCAAmC;EACnC,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA,0BAAe,aAAa,EAAE;;AAE9B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,cAAc;AAChB;AACA,8BAAkB,8BAA8B,EAAE,sCAAsC,EAAE;AAC1F,6BAAkB,gCAAgC,EAAE,qCAAqC,EAAE;;AAE3F,0BAAe,mCAAmC,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,0BAA0B,EAAE;AAC5H,0BAAe,kCAAkC,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,4BAA4B,EAAE,yBAAyB,EAAE;;AAEtJ,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,uBAAuB;AACzB;;AAEA,8BAAmB,aAAa,EAAE,sBAAsB,EAAE;AAC1D,8BAAmB,mCAAmC,EAAE,4BAA4B,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,gBAAgB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC3N,+BAAmB,mCAAmC,EAAE,gBAAgB,EAAE,0BAA0B,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AAClJ,8BAAmB,oBAAoB,EAAE,gBAAgB,EAAE;AAC3D,+BAAoB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,cAAc,EAAE;;AAE5G,4DAA4D;AAC5D;EACE;IACE,+BAA+B;IAC/B,6BAA6B;EAC/B;EACA,6BAAkB,eAAe,EAAE,kBAAkB,EAAE;EACvD,6BAAkB,cAAc,EAAE,WAAW,EAAE;EAC/C,6BAAkB,cAAc,EAAE,WAAW,EAAE,eAAe,EAAE,cAAc,EAAE;AAClF;;AAEA,oDAAoD;AACpD;EACE,6BAAkB,aAAa,EAAE;EACjC,6BAAkB,eAAe,EAAE;AACrC;;AAEA,yBAAc,oBAAoB,EAAE,cAAc,EAAE;;AAEpD;;2DAE2D;AAC3D;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA,yBAAc,kBAAkB,EAAE,QAAQ,EAAE,oBAAoB,EAAE;;AAElE;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,iCAAiC;EACjC,yFAAyF;EACzF,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;EACX,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,YAAY;AACd;;AAEA,wBAAa,oBAAoB,EAAE,aAAa,EAAE;;AAElD;EACE,mCAAmC;EACnC,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA,8BAAmB,oBAAoB,EAAE;;AAEzC;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,0DAA0D;EAC1D,eAAe;EACf,mBAAmB;EACnB,8CAA8C;EAC9C,uCAAuC;EACvC,aAAa;AACf;AACA;yCAC8B,2BAA2B,EAAE,iCAAiC,EAAE;AAC9F,yCAA8B,sCAAsC,EAAE,4CAA4C,EAAE;;AAEpH;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,sDAAsD;EACtD,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;EACnC,gBAAgB;EAChB,0DAA0D;EAC1D,uCAAuC;AACzC;AACA,6CAAkC,2BAA2B,EAAE,iCAAiC,EAAE,oBAAoB,EAAE;AACxH,iCAAsB,aAAa,EAAE,mBAAmB,EAAE;;AAE1D;EACE,aAAa;EACb,4BAA4B;EAC5B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,wDAAwD;EACxD,gBAAgB;EAChB,6BAA6B;AAC/B;AACA,4BAAgB,qBAAqB,EAAE;;AAEvC;EACE,iCAAiC;EACjC,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA,yBAAc,gBAAgB,EAAE,aAAa,EAAE,sBAAsB,EAAE,2BAA2B,EAAE;;AAEpG;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;;2DAE2D;AAC3D;EACE,WAAW;EACX,oCAAoC;EACpC,+BAA+B;EAC/B,sCAAsC;EACtC,2BAA2B;EAC3B,0BAA0B;EAC1B,mCAAmC;EACnC,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;AACA,+BAAoB,2BAA2B,EAAE;AACjD,sCAA2B,wBAAwB,EAAE,wBAAwB,EAAE;;AAE/E,uCAAuC;AACvC;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kCAAkC;EAClC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,+CAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;;2DAE2D;AAC3D;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,uDAAuD;EACvD,+BAA+B;EAC/B,sCAAsC;EACtC,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;EACjC,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;AACA,6BAAkB,2BAA2B,EAAE;AAC/C,oCAAyB,wBAAwB,EAAE,wBAAwB,EAAE,mCAAmC,EAAE;;AAElH;EACE,8BAA8B;EAC9B,uDAAuD;EACvD,+BAA+B;EAC/B,sCAAsC;EACtC,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;EACjC,wBAAwB;EACxB,aAAa;EACb,8BAA8B;AAChC;AACA,iCAAsB,2BAA2B,EAAE;AACnD,wCAA6B,wBAAwB,EAAE,mCAAmC,EAAE","sourcesContent":["/* ══════════════════════════════════════════════════════\n   Shell\n   ══════════════════════════════════════════════════════ */\n.shell {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: var(--bg);\n}\n\n/* ══════════════════════════════════════════════════════\n   Header\n   ══════════════════════════════════════════════════════ */\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 clamp(12px, 2vw, 28px);\n  min-height: clamp(44px, 6vh, 56px);\n  border-bottom: 1px solid var(--border);\n  background: var(--bg-card);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  flex-shrink: 0;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: clamp(14px, 1.4vw, 18px);\n  font-weight: 600;\n  color: var(--accent);\n  letter-spacing: -0.01em;\n  flex-shrink: 0;\n}\n\n.headerMeta {\n  display: flex;\n  align-items: center;\n  gap: clamp(6px, 0.8vw, 12px);\n  flex-wrap: wrap;\n}\n\n.fileName {\n  font-size: clamp(10px, 1vw, 12px);\n  color: var(--text-secondary);\n  font-family: var(--mono);\n  max-width: clamp(100px, 15vw, 220px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: clamp(10px, 0.9vw, 11px);\n  font-weight: 500;\n  padding: 3px clamp(6px, 0.8vw, 9px);\n  border-radius: 20px;\n  background: var(--accent-dim);\n  color: var(--accent);\n  border: 1px solid var(--accent-border);\n  white-space: nowrap;\n}\n\n.resetBtn {\n  display: flex;\n  align-items: center;\n  gap: clamp(4px, 0.5vw, 6px);\n  font-size: clamp(11px, 1vw, 12px);\n  font-weight: 500;\n  padding: clamp(4px, 0.6vh, 6px) clamp(8px, 1vw, 12px);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: transparent;\n  color: var(--text-secondary);\n  transition: background 0.15s, color 0.15s;\n  white-space: nowrap;\n}\n.resetBtn:hover {\n  background: var(--bg-card-hover);\n  color: var(--text-primary);\n}\n\n.accentBtn {\n  display: flex;\n  align-items: center;\n  gap: clamp(4px, 0.5vw, 6px);\n  font-size: clamp(11px, 1vw, 12px);\n  font-weight: 600;\n  padding: clamp(4px, 0.6vh, 7px) clamp(10px, 1.2vw, 16px);\n  border-radius: var(--radius-sm);\n  border: none;\n  background: var(--accent);\n  color: #0a0a0a;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n.accentBtn:hover { background: #e8c069; }\n\n.printBtn {\n  display: flex;\n  align-items: center;\n  gap: clamp(4px, 0.5vw, 6px);\n  padding: clamp(4px, 0.6vh, 7px) clamp(8px, 1vw, 14px);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--accent-border);\n  background: var(--accent-dim);\n  color: var(--accent);\n  font-size: clamp(11px, 1vw, 12px);\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s, border-color 0.15s;\n}\n.printBtn:hover:not(:disabled) {\n  background: rgba(212,168,67,0.2);\n  border-color: var(--accent);\n}\n.printBtn:disabled { opacity: 0.3; cursor: not-allowed; }\n\n/* ══════════════════════════════════════════════════════\n   Mapping Screen\n   ══════════════════════════════════════════════════════ */\n.mappingMain {\n  flex: 1;\n  padding: clamp(16px, 3vh, 32px) clamp(14px, 3vw, 28px);\n  max-width: min(860px, 100%);\n  width: 100%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: clamp(14px, 2.5vh, 24px);\n}\n\n.mappingHero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: clamp(12px, 2vw, 20px);\n  flex-wrap: wrap;\n}\n\n.mappingHeroText { display: flex; flex-direction: column; gap: 6px; }\n\n.mappingTitle {\n  font-size: clamp(14px, 1.8vw, 18px);\n  font-weight: 600;\n  color: var(--text-primary);\n  letter-spacing: -0.02em;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mappingSub {\n  font-size: clamp(11px, 1.1vw, 13px);\n  color: var(--text-secondary);\n  line-height: 1.5;\n  max-width: 520px;\n}\n\n.mappingGrid { display: flex; flex-direction: column; gap: clamp(5px, 0.8vh, 8px); }\n\n.mappingRow {\n  display: flex;\n  align-items: center;\n  gap: clamp(8px, 1vw, 12px);\n  padding: clamp(8px, 1.2vh, 12px) clamp(10px, 1.5vw, 16px);\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  background: var(--bg-card);\n  transition: border-color 0.15s;\n  flex-wrap: wrap;\n}\n\n.mappingRowResolved  { border-color: rgba(74,158,110,0.3); background: rgba(74,158,110,0.05); }\n.mappingRowUnresolved{ border-color: rgba(212,168,67,0.35); background: rgba(212,168,67,0.05); }\n\n.mappingFieldKey {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  font-size: clamp(10px, 1vw, 12px);\n  font-weight: 600;\n  font-family: var(--mono);\n  color: var(--text-primary);\n  min-width: clamp(120px, 15vw, 180px);\n  letter-spacing: 0.02em;\n}\n\n.mappingArrow   { color: var(--text-muted); flex-shrink: 0; }\n.resolvedIcon   { color: var(--success); flex-shrink: 0; }\n.warnIcon       { color: var(--accent); flex-shrink: 0; }\n\n.mappingSelect {\n  flex: 1;\n  min-width: 120px;\n  padding: clamp(5px, 0.8vh, 7px) 10px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: clamp(11px, 1.1vw, 12.5px);\n  font-family: var(--sans);\n  outline: none;\n  cursor: pointer;\n  transition: border-color 0.15s;\n}\n.mappingSelect:focus     { border-color: var(--accent); }\n.mappingSelectWarn       { border-color: rgba(212,168,67,0.5); color: var(--text-secondary); }\n\n.confirmBtn {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: clamp(7px, 1vh, 9px) clamp(14px, 1.5vw, 20px);\n  border-radius: var(--radius-sm);\n  border: none;\n  background: var(--accent);\n  color: #0f0f0f;\n  font-size: clamp(11px, 1.1vw, 13px);\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n  flex-shrink: 0;\n}\n.confirmBtn:hover { background: #e8c069; }\n\n.mappingFooter {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-top: 8px;\n  flex-wrap: wrap;\n}\n\n.mappingFooterNote { font-size: clamp(10px, 1vw, 12px); color: var(--text-muted); }\n\n/* ══════════════════════════════════════════════════════\n   Results strip\n   ══════════════════════════════════════════════════════ */\n.resultsStrip {\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border);\n  padding: 10px clamp(12px, 2vw, 20px);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.stripFields {\n  display: grid;\n  grid-template-columns: repeat(5, auto);\n  gap: 8px 14px;\n  align-items: flex-end;\n}\n\n.stripField { display: flex; flex-direction: column; gap: 3px; flex-shrink: 0; }\n\n.stripLabel {\n  font-size: 9px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.inputWrap { position: relative; display: flex; align-items: center; }\n\n.inputPrefix {\n  position: absolute;\n  left: 8px;\n  font-size: clamp(10px, 1vw, 12px);\n  color: var(--text-muted);\n  pointer-events: none;\n  z-index: 1;\n}\n\n.stripInput {\n  width: 80px;\n  padding: 5px 8px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: 12px;\n  font-family: var(--mono);\n  outline: none;\n  transition: border-color 0.15s;\n}\n.stripInput:focus { border-color: var(--accent); }\n.stripInput::placeholder { color: var(--text-muted); }\n.inputFieldPrefixed { padding-left: clamp(18px, 2vw, 22px); }\n\n.stripTextInput {\n  width: 110px;\n  padding: 5px 8px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: 12px;\n  font-family: var(--sans);\n  outline: none;\n  transition: border-color 0.15s;\n}\n.stripTextInput:focus { border-color: var(--accent); }\n.stripTextInput::placeholder { color: var(--text-muted); font-style: italic; }\n\n.stripSummary { display: flex; gap: 16px; flex-wrap: nowrap; overflow: hidden; }\n.stripStat { font-size: clamp(10px, 1vw, 12px); color: var(--text-secondary); }\n.stripStat strong { color: var(--text-secondary); font-weight: 500; }\n\n.bookToggle {\n  display: flex;\n  gap: 5px;\n}\n.bookToggleBtn {\n  padding: 5px 12px;\n  font-size: 11px;\n  font-weight: 500;\n  background: var(--bg-input);\n  color: var(--text-muted);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: background 0.12s, color 0.12s, border-color 0.12s;\n  white-space: nowrap;\n}\n.bookToggleBtn:hover { color: var(--text-primary); border-color: var(--accent-border); }\n.bookToggleActive {\n  background: var(--accent-dim) !important;\n  color: var(--accent) !important;\n  border-color: var(--accent) !important;\n  font-weight: 600;\n}\n\n.stripResetBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: clamp(26px, 2.5vw, 30px);\n  height: clamp(26px, 3vh, 30px);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: transparent;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: color 0.15s, border-color 0.15s;\n}\n.stripResetBtn:hover { color: var(--accent); border-color: var(--accent-border); }\n\n/* ══════════════════════════════════════════════════════\n   Results main\n   ══════════════════════════════════════════════════════ */\n.resultsMain {\n  flex: 1;\n  padding: clamp(12px, 2vh, 24px) clamp(14px, 2vw, 28px);\n  overflow-y: auto;\n}\n\n.resultsHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n  flex-wrap: wrap;\n}\n\n.resultsTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: clamp(14px, 1.5vw, 20px);\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.resultsTitleSub { font-size: clamp(11px, 1.1vw, 13px); font-weight: 400; color: var(--text-muted); }\n\n.filterPill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: clamp(10px, 0.9vw, 11px);\n  padding: 3px clamp(7px, 0.9vw, 10px);\n  border-radius: 20px;\n  background: var(--accent-dim);\n  color: var(--accent);\n  border: 1px solid var(--accent-border);\n}\n\n.noResults {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: clamp(32px, 8vh, 60px) 20px;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: clamp(12px, 1.2vw, 14px);\n}\n\n/* ── Deal cards ── */\n.dealCards { display: flex; flex-direction: column; gap: clamp(5px, 0.8vh, 8px); }\n\n/* ── Deal card: horizontal at full width, stacks on small screens ── */\n.dealCard {\n  display: grid;\n  /* Wide: rank | identity | financials all on one row */\n  grid-template-columns: 36px 1fr auto;\n  grid-template-rows: auto;\n  align-items: center;\n  column-gap: 20px;\n  padding: clamp(8px, 1.2vh, 14px) clamp(12px, 1.5vw, 20px);\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  background: var(--bg-card);\n  transition: border-color 0.15s;\n}\n.dealCard:hover   { border-color: var(--border-strong); }\n.dealCardPos      { border-left: 3px solid var(--success); }\n.dealCardNeg      { border-left: 3px solid #b85c38; }\n\n.dealRank {\n  font-size: clamp(12px, 1.1vw, 15px);\n  font-weight: 700;\n  color: var(--text-secondary);\n  font-family: var(--mono);\n  text-align: center;\n  flex-shrink: 0;\n}\n\n/* Identity: name on top, pills + equity below */\n.dealIdentity {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.dealVehicle {\n  font-size: clamp(13px, 1.3vw, 16px);\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.dealMeta {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 5px;\n  align-items: center;\n}\n\n.dealMetaItem {\n  font-size: clamp(10px, 0.85vw, 11px);\n  color: var(--text-secondary);\n  background: var(--bg-input);\n  padding: 2px 7px;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  white-space: nowrap;\n}\n.dealMetaVin { display: none; }\n\n.equityBadge {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 10px;\n  border-radius: var(--radius-sm);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.equityBadgePos { background: var(--success-dim); border: 1px solid rgba(74,158,110,0.3); }\n.equityBadgeNeg { background: rgba(184,92,56,0.12); border: 1px solid rgba(184,92,56,0.3); }\n\n.equityPct   { font-size: clamp(12px, 1.1vw, 14px); font-weight: 700; font-family: var(--mono); color: var(--text-primary); }\n.equityLabel { font-size: clamp(9px, 0.8vw, 10px); font-weight: 500; letter-spacing: 0.04em; color: var(--text-secondary); text-transform: uppercase; }\n\n/* Financials: horizontal row at full width */\n.dealFinancials {\n  display: flex;\n  flex-direction: row;\n  gap: clamp(14px, 2vw, 28px);\n  flex-shrink: 0;\n  align-items: flex-start;\n}\n\n.dealFin         { display: flex; flex-direction: column; }\n.dealFinLabel    { font-size: clamp(9px, 0.75vw, 10px); color: var(--text-secondary); font-weight: 500; letter-spacing: 0.04em; text-transform: uppercase; line-height: 1.2; display: flex; align-items: center; gap: 4px; }\n.dealFinVal      { font-size: clamp(12px, 1.1vw, 14px); font-weight: 500; color: var(--text-primary); font-family: var(--mono); line-height: 1.3; }\n.dealFinPmt      { color: var(--accent); font-weight: 600; }\n.dealFinActiveDot { width: 4px; height: 4px; border-radius: 50%; background: var(--accent); flex-shrink: 0; }\n\n/* Responsive: below 860px stack identity above financials */\n@media (max-width: 860px) {\n  .dealCard {\n    grid-template-columns: 28px 1fr;\n    grid-template-rows: auto auto;\n  }\n  .dealRank       { grid-row: 1 / 3; align-self: center; }\n  .dealIdentity   { grid-column: 2; grid-row: 1; }\n  .dealFinancials { grid-column: 2; grid-row: 2; flex-wrap: wrap; gap: 10px 20px; }\n}\n\n/* Responsive: below 500px wrap financials tightly */\n@media (max-width: 500px) {\n  .dealFinancials { gap: 8px 14px; }\n  .dealVehicle    { font-size: 13px; }\n}\n\n.accentIcon { color: var(--accent); flex-shrink: 0; }\n\n/* ══════════════════════════════════════════════════════\n   Homepage\n   ══════════════════════════════════════════════════════ */\n.homepageShell {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #0a0a0a;\n  position: relative;\n  overflow: hidden;\n  padding: clamp(12px, 2vh, 20px) clamp(16px, 4vw, 32px);\n}\n\n.homepageBg { position: absolute; inset: 0; pointer-events: none; }\n\n.bgGlow {\n  position: absolute;\n  top: -20%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: min(700px, 90vw);\n  height: clamp(200px, 40vh, 400px);\n  background: radial-gradient(ellipse at center, rgba(212,168,67,0.07) 0%, transparent 70%);\n  border-radius: 50%;\n}\n\n.homepageContent {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  max-width: min(580px, 100%);\n  width: 100%;\n  gap: 0;\n}\n\n.homeLogoRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: clamp(8px, 1.5vh, 14px);\n  opacity: 0.5;\n}\n\n.homeLogo  { color: var(--accent); display: flex; }\n\n.homeLogoText {\n  font-size: clamp(10px, 1.1vw, 12px);\n  font-weight: 500;\n  color: var(--text-secondary);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.homeTitle {\n  font-size: clamp(26px, 4.5vw, 44px);\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n  color: #f0f0f0;\n  margin-bottom: clamp(6px, 1vh, 10px);\n}\n\n.homeTitleAccent { color: var(--accent); }\n\n.homeSubtitle {\n  font-size: clamp(13px, 1.3vw, 15px);\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: clamp(12px, 2vh, 20px);\n  max-width: 380px;\n}\n\n.homeDropZone {\n  width: 100%;\n  border: 1px solid #2a2a2a;\n  border-radius: 14px;\n  padding: clamp(14px, 2.5vh, 22px) clamp(16px, 2.5vw, 28px);\n  cursor: pointer;\n  background: #111111;\n  transition: border-color 0.2s, background 0.2s;\n  margin-bottom: clamp(10px, 1.8vh, 18px);\n  outline: none;\n}\n.homeDropZone:hover,\n.homeDropZone:focus-visible { border-color: var(--accent); background: rgba(212,168,67,0.04); }\n.homeDropZoneActive         { border-color: var(--accent) !important; background: rgba(212,168,67,0.08) !important; }\n\n.homeDropInner {\n  display: flex;\n  align-items: center;\n  gap: clamp(10px, 1.5vw, 16px);\n  text-align: left;\n}\n\n.homeDropIconWrap {\n  width: clamp(36px, 4vw, 44px);\n  height: clamp(36px, 4vw, 44px);\n  border-radius: 10px;\n  background: rgba(212,168,67,0.1);\n  border: 1px solid rgba(212,168,67,0.2);\n  color: var(--accent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.homeDropMain {\n  font-size: clamp(13px, 1.4vw, 15px);\n  font-weight: 500;\n  color: #f0f0f0;\n  margin-bottom: 3px;\n}\n\n.homeDropSub {\n  font-size: clamp(10px, 1vw, 12px);\n  color: var(--text-muted);\n  font-family: var(--mono);\n  letter-spacing: 0.02em;\n}\n\n.toyotaBtn {\n  width: 100%;\n  border: 1px solid #2a2a2a;\n  border-radius: 10px;\n  padding: clamp(6px, 1vh, 9px) clamp(16px, 2.5vw, 28px);\n  cursor: pointer;\n  background: #111111;\n  color: var(--text-secondary);\n  font-size: clamp(11px, 1.1vw, 13px);\n  font-weight: 500;\n  transition: border-color 0.2s, background 0.2s, color 0.2s;\n  margin-bottom: clamp(10px, 1.8vh, 18px);\n}\n.toyotaBtn:hover:not(:disabled) { border-color: var(--accent); background: rgba(212,168,67,0.04); color: var(--accent); }\n.toyotaBtn:disabled { opacity: 0.35; cursor: not-allowed; }\n\n.bubbleRow {\n  display: flex;\n  gap: clamp(8px, 1.2vw, 12px);\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.bubble {\n  flex: 1;\n  min-width: clamp(130px, 20vw, 160px);\n  background: #111111;\n  border: 1px solid #1e1e1e;\n  border-radius: 14px;\n  padding: clamp(12px, 2vh, 18px) clamp(12px, 1.6vw, 20px);\n  text-align: left;\n  transition: border-color 0.2s;\n}\n.bubble:hover { border-color: #2a2a2a; }\n\n.bubbleTitle {\n  font-size: clamp(10px, 1vw, 12px);\n  font-weight: 600;\n  color: var(--accent);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-bottom: clamp(8px, 1.2vh, 12px);\n}\n\n.bubbleList { list-style: none; display: flex; flex-direction: column; gap: clamp(5px, 0.8vh, 7px); }\n\n.bubbleItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: clamp(10px, 1vw, 12px);\n  color: var(--text-secondary);\n  line-height: 1.4;\n}\n\n.bubbleDot {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--accent);\n  opacity: 0.6;\n  flex-shrink: 0;\n}\n\n/* ══════════════════════════════════════════════════════\n   Inputs screen (kept for reference, unused in flow)\n   ══════════════════════════════════════════════════════ */\n.inputField {\n  width: 100%;\n  padding: clamp(6px, 0.9vh, 8px) 10px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: clamp(11px, 1.1vw, 13px);\n  font-family: var(--mono);\n  outline: none;\n  transition: border-color 0.15s;\n}\n.inputField:focus { border-color: var(--accent); }\n.inputField::placeholder { color: var(--text-muted); font-family: var(--sans); }\n\n/* ── Cards wrap + loading overlay ── */\n.cardsWrap {\n  position: relative;\n  min-height: 120px;\n}\n\n/* Blurs the cards behind the overlay while keeping header/strip fully usable */\n.cardsOverlay {\n  position: absolute;\n  inset: 0;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: rgba(10, 10, 10, 0.75);\n  backdrop-filter: blur(4px);\n  border-radius: var(--radius);\n}\n\n.loadingSpinner {\n  width: 28px;\n  height: 28px;\n  border: 2px solid var(--border-strong);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spin 0.7s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.loadingText {\n  font-size: 12px;\n  color: var(--text-secondary);\n  letter-spacing: 0.03em;\n}\n\n/* ══════════════════════════════════════════════════════\n   Unified results header\n   ══════════════════════════════════════════════════════ */\n.uniHeader {\n  background: var(--bg-card);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n/* Top bar */\n.uniTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 24px;\n  border-bottom: 1px solid var(--border);\n  gap: 16px;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: var(--bg-card);\n}\n\n.uniActions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Inputs row */\n.uniInputs {\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  padding: 12px 24px;\n  flex-wrap: wrap;\n}\n\n.uniField {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex-shrink: 0;\n}\n\n.uniDivider {\n  width: 1px;\n  align-self: stretch;\n  margin: 2px 2px 4px;\n  background: var(--border-strong);\n  flex-shrink: 0;\n}\n\n.uniLabel {\n  font-size: clamp(9px, 0.8vw, 11px);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.uniInput {\n  width: clamp(70px, 6vw, 96px);\n  padding: clamp(5px, 0.6vh, 8px) clamp(7px, 0.6vw, 10px);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: clamp(12px, 1vw, 14px);\n  font-family: var(--mono);\n  outline: none;\n  transition: border-color 0.15s;\n}\n.uniInput:focus { border-color: var(--accent); }\n.uniInput::placeholder { color: var(--text-muted); font-family: var(--sans); font-size: clamp(10px, 0.8vw, 11px); }\n\n.uniTextInput {\n  width: clamp(90px, 9vw, 130px);\n  padding: clamp(5px, 0.6vh, 8px) clamp(7px, 0.6vw, 10px);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-strong);\n  background: var(--bg-input);\n  color: var(--text-primary);\n  font-size: clamp(12px, 1vw, 14px);\n  font-family: var(--sans);\n  outline: none;\n  transition: border-color 0.15s;\n}\n.uniTextInput:focus { border-color: var(--accent); }\n.uniTextInput::placeholder { color: var(--text-muted); font-size: clamp(10px, 0.8vw, 11px); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": `App_shell__1G2Ca`,
	"header": `App_header__fhC8n`,
	"logo": `App_logo__7Edbg`,
	"headerMeta": `App_headerMeta__NZ5se`,
	"fileName": `App_fileName__n-w-P`,
	"pill": `App_pill__RQ45j`,
	"resetBtn": `App_resetBtn__pi8Jm`,
	"accentBtn": `App_accentBtn__X21GN`,
	"printBtn": `App_printBtn__ms2e8`,
	"mappingMain": `App_mappingMain__olV7f`,
	"mappingHero": `App_mappingHero__ERTMW`,
	"mappingHeroText": `App_mappingHeroText__u0skE`,
	"mappingTitle": `App_mappingTitle__RT26L`,
	"mappingSub": `App_mappingSub__cFZ+r`,
	"mappingGrid": `App_mappingGrid__Vsyiw`,
	"mappingRow": `App_mappingRow__hRcej`,
	"mappingRowResolved": `App_mappingRowResolved__eVL3L`,
	"mappingRowUnresolved": `App_mappingRowUnresolved__xgMeR`,
	"mappingFieldKey": `App_mappingFieldKey__lknGS`,
	"mappingArrow": `App_mappingArrow__fglhS`,
	"resolvedIcon": `App_resolvedIcon__KnOCJ`,
	"warnIcon": `App_warnIcon__O5y+U`,
	"mappingSelect": `App_mappingSelect__+a76a`,
	"mappingSelectWarn": `App_mappingSelectWarn__2JYY1`,
	"confirmBtn": `App_confirmBtn__dY1pQ`,
	"mappingFooter": `App_mappingFooter__68uEv`,
	"mappingFooterNote": `App_mappingFooterNote__6QR3N`,
	"resultsStrip": `App_resultsStrip__h0-U+`,
	"stripFields": `App_stripFields__UGwLM`,
	"stripField": `App_stripField__BQ9D1`,
	"stripLabel": `App_stripLabel__IvuoJ`,
	"inputWrap": `App_inputWrap__W8dgk`,
	"inputPrefix": `App_inputPrefix__O+vet`,
	"stripInput": `App_stripInput__GUxcc`,
	"inputFieldPrefixed": `App_inputFieldPrefixed__jv-Dy`,
	"stripTextInput": `App_stripTextInput__kw4xN`,
	"stripSummary": `App_stripSummary__ih-Sw`,
	"stripStat": `App_stripStat__qGJHc`,
	"bookToggle": `App_bookToggle__Ieseu`,
	"bookToggleBtn": `App_bookToggleBtn__p2o-I`,
	"bookToggleActive": `App_bookToggleActive__2wRav`,
	"stripResetBtn": `App_stripResetBtn__esLf8`,
	"resultsMain": `App_resultsMain__3kuf4`,
	"resultsHeader": `App_resultsHeader__BGeej`,
	"resultsTitle": `App_resultsTitle__P6aDE`,
	"resultsTitleSub": `App_resultsTitleSub__WUipk`,
	"filterPill": `App_filterPill__G2F-4`,
	"noResults": `App_noResults__w9NW1`,
	"dealCards": `App_dealCards__b16r7`,
	"dealCard": `App_dealCard__OqroL`,
	"dealCardPos": `App_dealCardPos__Tn7bs`,
	"dealCardNeg": `App_dealCardNeg__WsjTp`,
	"dealRank": `App_dealRank__GoIrw`,
	"dealIdentity": `App_dealIdentity__cqyMD`,
	"dealVehicle": `App_dealVehicle__gDtzj`,
	"dealMeta": `App_dealMeta__Nqk4Q`,
	"dealMetaItem": `App_dealMetaItem__P9bdf`,
	"dealMetaVin": `App_dealMetaVin__dMuzW`,
	"equityBadge": `App_equityBadge__M3JjV`,
	"equityBadgePos": `App_equityBadgePos__Bn+Ka`,
	"equityBadgeNeg": `App_equityBadgeNeg__rzE-0`,
	"equityPct": `App_equityPct__Jdpa6`,
	"equityLabel": `App_equityLabel__GjQfh`,
	"dealFinancials": `App_dealFinancials__fYR1k`,
	"dealFin": `App_dealFin__C8BvO`,
	"dealFinLabel": `App_dealFinLabel__RIL96`,
	"dealFinVal": `App_dealFinVal__+g9CA`,
	"dealFinPmt": `App_dealFinPmt__FWuOc`,
	"dealFinActiveDot": `App_dealFinActiveDot__6P6gP`,
	"accentIcon": `App_accentIcon__UqAgq`,
	"homepageShell": `App_homepageShell__fG4YA`,
	"homepageBg": `App_homepageBg__Sxcw0`,
	"bgGlow": `App_bgGlow__dJAei`,
	"homepageContent": `App_homepageContent__sVkLj`,
	"homeLogoRow": `App_homeLogoRow__6LggL`,
	"homeLogo": `App_homeLogo__BiQes`,
	"homeLogoText": `App_homeLogoText__kSt-n`,
	"homeTitle": `App_homeTitle__I-LO1`,
	"homeTitleAccent": `App_homeTitleAccent__ygi-q`,
	"homeSubtitle": `App_homeSubtitle__m4YLk`,
	"homeDropZone": `App_homeDropZone__1vM2K`,
	"homeDropZoneActive": `App_homeDropZoneActive__zsR2x`,
	"homeDropInner": `App_homeDropInner__R4jsc`,
	"homeDropIconWrap": `App_homeDropIconWrap__+ZSVT`,
	"homeDropMain": `App_homeDropMain__tZEYb`,
	"homeDropSub": `App_homeDropSub__dcBMk`,
	"toyotaBtn": `App_toyotaBtn__beOvP`,
	"bubbleRow": `App_bubbleRow__xE8HR`,
	"bubble": `App_bubble__nkS+b`,
	"bubbleTitle": `App_bubbleTitle__FDbXM`,
	"bubbleList": `App_bubbleList__1XG08`,
	"bubbleItem": `App_bubbleItem__seDpk`,
	"bubbleDot": `App_bubbleDot__PV7-N`,
	"inputField": `App_inputField__Z1sjo`,
	"cardsWrap": `App_cardsWrap__BOSoD`,
	"cardsOverlay": `App_cardsOverlay__GPUbh`,
	"loadingSpinner": `App_loadingSpinner__mIlB6`,
	"spin": `App_spin__RBUaI`,
	"loadingText": `App_loadingText__qJ1ef`,
	"uniHeader": `App_uniHeader__g7P-j`,
	"uniTop": `App_uniTop__sGmT8`,
	"uniActions": `App_uniActions__ygNrc`,
	"uniInputs": `App_uniInputs__dxrKy`,
	"uniField": `App_uniField__zjNee`,
	"uniDivider": `App_uniDivider__oqE9F`,
	"uniLabel": `App_uniLabel__gNHCR`,
	"uniInput": `App_uniInput__VZepD`,
	"uniTextInput": `App_uniTextInput__eAZBs`
};
export default ___CSS_LOADER_EXPORT___;
